import { gsap } from '../animations';

/**
 * Stage scroll-scrubbed del block Presentazione: la "card" di sfondo cresce
 * da scale 0.86 (angoli arrotondati) a full-bleed mentre la sezione entra.
 */
export function initPresentazione() {
	if ( window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches ) {
		return;
	}

	document.querySelectorAll( '.tm-presentazione' ).forEach( ( section ) => {
		const stage = section.querySelector( '[data-pres-stage]' );
		if ( ! stage ) {
			return;
		}

		gsap.fromTo(
			stage,
			{ scale: 0.86, borderRadius: '18px' },
			{
				scale: 1,
				borderRadius: '0px',
				ease: 'none',
				scrollTrigger: {
					trigger: section,
					start: 'top bottom',
					end: 'center center',
					scrub: 0.5,
				},
			}
		);
	} );
}
